// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file llm/v1/chat.proto (package llm.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file llm/v1/chat.proto.
 */
export const file_llm_v1_chat: GenFile = /*@__PURE__*/
  fileDesc("ChFsbG0vdjEvY2hhdC5wcm90bxIGbGxtLnYxIoEBCgtDaGF0UmVxdWVzdBIPCgdjb250ZW50GAEgASgJEhUKDXN5c3RlbV9wcm9tcHQYAiABKAkSDQoFbW9kZWwYAyABKAkSEgoKcmVmZXJlbmNlcxgEIAEoCRISCgptYXhfdG9rZW5zGAUgASgFEhMKC3RlbXBlcmF0dXJlGAYgASgBIqwBCgxDaGF0UmVzcG9uc2USHwoEdHlwZRgBIAEoDjIRLmxsbS52MS5DaHVua1R5cGUSDwoHY29udGVudBgCIAEoCRIhCgV1c2FnZRgDIAEoCzISLmxsbS52MS5Ub2tlblVzYWdlEgwKBGRvbmUYBCABKAgSEAoIYmxvY2tfaWQYBSABKAkSJwoLYmxvY2tfZXZlbnQYBiABKA4yEi5sbG0udjEuQmxvY2tFdmVudCJUCgpUb2tlblVzYWdlEhQKDGlucHV0X3Rva2VucxgBIAEoBRIVCg1vdXRwdXRfdG9rZW5zGAIgASgFEhkKEWNhY2hlX3JlYWRfdG9rZW5zGAMgASgFKlUKCkJsb2NrRXZlbnQSGwoXQkxPQ0tfRVZFTlRfVU5TUEVDSUZJRUQQABIVChFCTE9DS19FVkVOVF9TVEFSVBABEhMKD0JMT0NLX0VWRU5UX0VORBACKooBCglDaHVua1R5cGUSGgoWQ0hVTktfVFlQRV9VTlNQRUNJRklFRBAAEhYKEkNIVU5LX1RZUEVfQ09OVEVOVBABEhcKE0NIVU5LX1RZUEVfVEhJTktJTkcQAhIXChNDSFVOS19UWVBFX0NJVEFUSU9OEAMSFwoTQ0hVTktfVFlQRV9UT09MX1VTRRAEMkQKC0NoYXRTZXJ2aWNlEjUKBENoYXQSEy5sbG0udjEuQ2hhdFJlcXVlc3QaFC5sbG0udjEuQ2hhdFJlc3BvbnNlIgAwAUI5WjdnaXRodWIuY29tL3VuaXBob3JlL3N1bnN0b25lL3BrZy9nby9nZW4vcGIvbGxtL3YxO2xsbVYxYgZwcm90bzM");

/**
 * ChatRequest represents a single message in the chat stream
 *
 * @generated from message llm.v1.ChatRequest
 */
export type ChatRequest = Message<"llm.v1.ChatRequest"> & {
  /**
   * The user's message content
   *
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * Optional system prompt (only used in first message)
   *
   * @generated from field: string system_prompt = 2;
   */
  systemPrompt: string;

  /**
   * Optional model selection (defaults to configured default)
   *
   * @generated from field: string model = 3;
   */
  model: string;

  /**
   * Optional references/context to include
   *
   * @generated from field: string references = 4;
   */
  references: string;

  /**
   * Optional maximum tokens for response
   *
   * @generated from field: int32 max_tokens = 5;
   */
  maxTokens: number;

  /**
   * Optional temperature for response generation
   *
   * @generated from field: double temperature = 6;
   */
  temperature: number;
};

/**
 * Describes the message llm.v1.ChatRequest.
 * Use `create(ChatRequestSchema)` to create a new message.
 */
export const ChatRequestSchema: GenMessage<ChatRequest> = /*@__PURE__*/
  messageDesc(file_llm_v1_chat, 0);

/**
 * ChatResponse represents a streaming chunk from the LLM
 *
 * @generated from message llm.v1.ChatResponse
 */
export type ChatResponse = Message<"llm.v1.ChatResponse"> & {
  /**
   * Type of chunk
   *
   * @generated from field: llm.v1.ChunkType type = 1;
   */
  type: ChunkType;

  /**
   * Content of the chunk
   *
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * Token usage (only present in final chunk)
   *
   * @generated from field: llm.v1.TokenUsage usage = 3;
   */
  usage?: TokenUsage;

  /**
   * Indicates this is the final chunk
   *
   * @generated from field: bool done = 4;
   */
  done: boolean;

  /**
   * Unique identifier for the block this chunk belongs to
   *
   * @generated from field: string block_id = 5;
   */
  blockId: string;

  /**
   * Lifecycle signal for block boundaries
   *
   * @generated from field: llm.v1.BlockEvent block_event = 6;
   */
  blockEvent: BlockEvent;
};

/**
 * Describes the message llm.v1.ChatResponse.
 * Use `create(ChatResponseSchema)` to create a new message.
 */
export const ChatResponseSchema: GenMessage<ChatResponse> = /*@__PURE__*/
  messageDesc(file_llm_v1_chat, 1);

/**
 * TokenUsage tracks token consumption
 *
 * @generated from message llm.v1.TokenUsage
 */
export type TokenUsage = Message<"llm.v1.TokenUsage"> & {
  /**
   * @generated from field: int32 input_tokens = 1;
   */
  inputTokens: number;

  /**
   * @generated from field: int32 output_tokens = 2;
   */
  outputTokens: number;

  /**
   * For providers with prompt caching
   *
   * @generated from field: int32 cache_read_tokens = 3;
   */
  cacheReadTokens: number;
};

/**
 * Describes the message llm.v1.TokenUsage.
 * Use `create(TokenUsageSchema)` to create a new message.
 */
export const TokenUsageSchema: GenMessage<TokenUsage> = /*@__PURE__*/
  messageDesc(file_llm_v1_chat, 2);

/**
 * BlockEvent signals block lifecycle boundaries in the stream
 *
 * @generated from enum llm.v1.BlockEvent
 */
export enum BlockEvent {
  /**
   * @generated from enum value: BLOCK_EVENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * First chunk of a new block
   *
   * @generated from enum value: BLOCK_EVENT_START = 1;
   */
  START = 1,

  /**
   * Final chunk of a closing block
   *
   * @generated from enum value: BLOCK_EVENT_END = 2;
   */
  END = 2,
}

/**
 * Describes the enum llm.v1.BlockEvent.
 */
export const BlockEventSchema: GenEnum<BlockEvent> = /*@__PURE__*/
  enumDesc(file_llm_v1_chat, 0);

/**
 * ChunkType discriminates different types of response content
 *
 * @generated from enum llm.v1.ChunkType
 */
export enum ChunkType {
  /**
   * @generated from enum value: CHUNK_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Regular response content
   *
   * @generated from enum value: CHUNK_TYPE_CONTENT = 1;
   */
  CONTENT = 1,

  /**
   * Extended thinking content (Claude)
   *
   * @generated from enum value: CHUNK_TYPE_THINKING = 2;
   */
  THINKING = 2,

  /**
   * Citation/reference
   *
   * @generated from enum value: CHUNK_TYPE_CITATION = 3;
   */
  CITATION = 3,

  /**
   * Tool use indication
   *
   * @generated from enum value: CHUNK_TYPE_TOOL_USE = 4;
   */
  TOOL_USE = 4,
}

/**
 * Describes the enum llm.v1.ChunkType.
 */
export const ChunkTypeSchema: GenEnum<ChunkType> = /*@__PURE__*/
  enumDesc(file_llm_v1_chat, 1);

/**
 * ChatService provides streaming LLM interactions
 *
 * @generated from service llm.v1.ChatService
 */
export const ChatService: GenService<{
  /**
   * Chat sends a single request and receives a stream of response chunks
   *
   * @generated from rpc llm.v1.ChatService.Chat
   */
  chat: {
    methodKind: "server_streaming";
    input: typeof ChatRequestSchema;
    output: typeof ChatResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_llm_v1_chat, 0);

